export const API_HOST = "https://api.scorevision.site/"

/**
 * Same host, over a socket.
 *
 * A mobile money payment is confirmed by the provider minutes after it is asked for, so the client
 * subscribes to its transaction here rather than polling the API until something changes.
 */
export const WS_API_HOST = API_HOST.replace(/^http/, "ws").replace(/\/$/, "")

export const SUPPORT_EMAIL = "support@scorevision.zeejaylabs.dev"
// export const HOST = "http://localhost:7000";